export const actionTypes = {
  TOGGLE_SIDEBAR: 'TOGGLE_SIDEBAR',
  SET_TOPTRENDS_LIST: 'SET_TOPTRENDS_LIST',
  SET_FULL_SCREEN: 'SET_FULL_SCREEN',
  SET_EXPLORES_DATA: 'SET_EXPLORES_DATA',
  SET_LOOKS_LIST: 'SET_LOOKS_LIST',
  SET_DASHBOARDS_LIST: 'SET_DASHBOARDS_LIST',
  SET_BLOB_URL: 'SET_BLOB_URL',
  SET_EMBED_FOLDER_ID: 'SET_EMBED_FOLDER_ID',
  SET_LOOKER_PERMISSIONS: 'SET_LOOKER_PERMISSIONS',
  SET_SNACKBAR: 'SET_SNACKBAR',
  SET_ADHOC_ANALYSIS_FOLDERS: 'SET_ADHOC_ANALYSIS_FOLDERS',
  SET_SEGMENT_FILTERS_DATA: 'SET_SEGMENT_FILTERS_DATA',
  ADD_LOADER: 'ADD_LOADER',
  REMOVE_LOADER: 'REMOVE_LOADER',
  SET_COMPETITORS_DATA: 'SET_COMPETITORS_DATA',
  SET_TOP_N_DATA: 'SET_TOP_N_DATA',
  SET_DRILL_DOWN_ROW_DATA: 'SET_DRILL_DOWN_ROW_DATA',
  UPDATE_GT_SELECTED_FILTERS: 'UPDATE_GT_SELECTED_FILTERS',
  UPDATE_ST_SELECTED_FILTERS: 'UPDATE_ST_SELECTED_FILTERS',
  SET_HEADER_INFO: 'SET_HEADER_INFO',
  UNSET_HEADER_INFO: 'UNSET_HEADER_INFO',
  SET_AUTO_LOGGED: 'SET_AUTO_LOGGED',
  SET_POTENTIAL_OPPORTUNITY_LIST: 'SET_POTENTIAL_OPPORTUNITY_LIST',
  SET_TOP_OPPORTUNITY_LIST: 'SET_TOP_OPPORTUNITY_LIST',
  SET_GROWTH_TREND_MARKET_SHARE_FILTERS: 'SET_GROWTH_TREND_MARKET_SHARE_FILTERS',
  SET_USABILITY_RECOMMENDATION_LIST: 'SET_USABILITY_RECOMMENDATION_LIST',
  SET_PAGES_UPLOADS: 'SET_PAGES_UPLOADS',
  SET_KEYWORDS_UPLOADS: 'SET_KEYWORDS_UPLOADS',
  SET_PRIMARY_SEGMENT_NAME: 'SET_PRIMARY_SEGMENT_NAME',
  SET_SECONDARY_SEGMENT_NAME: 'SET_SECONDARY_SEGMENT_NAME',
  SET_SLACK_CHANNELS: 'SET_SLACK_CHANNELS',
  SET_CUSTOMER_INFO: 'SET_CUSTOMER_INFO',
  SET_GLOBAL_DATE_RANGE_FILTERS: 'SET_GLOBAL_DATE_RANGE_FILTERS',
  SET_USER_SELECTED_DATE_RANGE: 'SET_USER_SELECTED_DATE_RANGE',
  SET_DEFAULT_DATE_RANGE: 'SET_DEFAULT_DATE_RANGE',
  SET_SUMMARY_METRIC_DATA: 'SET_SUMMARY_METRIC_DATA',
  SET_DRILLDOWN_METRIC_DATA: 'SET_DRILLDOWN_METRIC_DATA',
  SET_RECOMMENDATION_FILTERS_DATA: 'SET_RECOMMENDATION_FILTERS_DATA',
  SET_CONTENT_RECOMMENDATION_FILTERS_DATA: 'SET_CONTENT_RECOMMENDATION_FILTERS_DATA',
  SET_CONTENT_RECOMMENDATION_DATA: 'SET_CONTENT_RECOMMENDATION_DATA',
  SET_CONTENT_BRIEF_DATA: 'SET_CONTENT_BRIEF_DATA',
  SET_USABILITY_METRICS_SCORE: 'SET_USABILITY_METRICS_SCORE',
  SET_DOMAIN: 'SET_DOMAIN',
  SET_MARKET_SEGMENT: 'SET_MARKET_SEGMENT',
  SET_CONFIRMATION_MODAL: 'SET_CONFIRMATION_MODAL',
  SET_CR_DETAILS_MODAL: 'SET_CR_DETAILS_MODAL',
  SET_LOOKER_USER_ID: 'SET_LOOKER_USER_ID',
  SET_INTENT_LIST: 'SET_INTENT_LIST',
  SET_RULES_LIST: 'SET_RULES_LIST',
  SET_ENTITY_LIST: 'SET_ENTITY_LIST',
  STORE_RULES_LIST: 'STORE_RULES_LIST',
  SET_ALL_SEARCH_INTENT_LIST: 'SET_ALL_SEARCH_INTENT_LIST',
  SET_ELEMENT_MAPPING_DETAILS: 'SET_ELEMENT_MAPPING_DETAILS',
  SET_ELEMENT_MAPPING_DETAILS_COMPETITOR: 'SET_ELEMENT_MAPPING_DETAILS_COMPETITOR',
  SET_CUSTOMER_PREVIEW_HTML: 'SET_CUSTOMER_PREVIEW_HTML',
  SET_INTENT_SUMMARY: 'SET_INTENT_SUMMARY',
  SET_ALL_SEARCH_INTENT_SUMMARY: 'SET_ALL_SEARCH_INTENT_SUMMARY',
  SET_CATEGORY_LIST: 'SET_CATEGORY_LIST',
  SET_CATEGORY_PAGE_LIST: 'SET_CATEGORY_PAGE_LIST',
  SET_CATEGORY_SUMMARY: 'SET_CATEGORY_SUMMARY',
  SET_ALL_SEARCH_CATEGORY_LIST: 'SET_ALL_SEARCH_CATEGORY_LIST',
  SET_ALL_SEARCH_CATEGORY_SUMMARY: 'SET_ALL_SEARCH_CATEGORY_SUMMARY',
  UPDATE_CONTENT_QUALITY_SCORE: 'UPDATE_CONTENT_QUALITY_SCORE',
  CR_FULL_SCREEN_SPINNER: 'CR_FULL_SCREEN_SPINNER',
  KEYWORDS_DATA: 'KEYWORDS_DATA',
  RE_UPDATE_ALL_KEYWORDS_DATA: 'RE_UPDATE_ALL_KEYWORDS_DATA',
  CR_PAGE_TAGS_HTML_DATA_COLLECTION: 'CR_PAGE_TAGS_HTML_DATA_COLLECTION', // like h1:[{all h1 data of page}], h2:[{all h2 data of page}], p:[]
  PAGE_ALL_HTML_DATA: 'PAGE_ALL_HTML_DATA',
  ALL_COMPETITORS_HTML_DATA: 'ALL_COMPETITORS_HTML_DATA',
  TOPICS_DATA: 'TOPICS_DATA',
  SET_CONTENT_RECOMMENDATION_PAGE_FILTERS_DATA: 'SET_CONTENT_RECOMMENDATION_PAGE_FILTERS_DATA',
  POTENTIAL_KEYWORDS_DATA: 'POTENTIAL_KEYWORDS_DATA',
  AI_KEYWORDS_DATA: 'AI_KEYWORDS_DATA',
  IS_INCLUDED_KEYWORDS_PIPELINE_TRIGGER: 'IS_INCLUDED_KEYWORDS_PIPELINE_TRIGGER',
  NEW_KEYWORD_TO_POTENTIAL_KEYWORDS_DATA: 'NEW_KEYWORD_TO_POTENTIAL_KEYWORDS_DATA',
  MASTER_COUNTRY_AND_LANGUAGE: 'MASTER_COUNTRY_AND_LANGUAGE',
  SET_NEW_PAGE_CONTENT_RECOMMENDATION_DATA: 'SET_NEW_PAGE_CONTENT_RECOMMENDATION_DATA',
  ADD_NEW_PAGE_IN_CR_FILTERS: 'ADD_NEW_PAGE_IN_CR_FILTERS',
  GLOBAL_AUTO_WRITER_MAGIC_PIN: 'GLOBAL_AUTO_WRITER_MAGIC_PIN',
  SET_CONTENT_BRIEF_TINYMCE_STRING: 'SET_CONTENT_BRIEF_TINYMCE_STRING',
  SET_GPT_STREAMING_DATA: 'SET_GPT_STREAMING_DATA',
  SET_WEB_SOCKET_INSTANCE: 'SET_WEB_SOCKET_INSTANCE',
  SET_SHOW_SUBSCRIPTION_BANNER: 'SET_SHOW_SUBSCRIPTION_BANNER',
  SET_CUSTOM_POPUP_STATUS: 'SET_CUSTOM_POPUP_STATUS',
  SET_SUBSCRIBER_META: 'SET_SUBSCRIBER_META',
  ADD_PAGE_TO_OPTIMIZE_FORM_BOX: 'ADD_PAGE_TO_OPTIMIZE_FORM_BOX',
  SET_CREDITS_REMAINING: 'SET_CREDITS_REMAINING',
  SET_CREDITS_REQUIRED_PER_DAY: 'SET_CREDITS_REQUIRED_PER_DAY',
  SET_INTERNAL_LINKING_FILTERS: 'SET_INTERNAL_LINKING_FILTERS',
  SET_AUTONOMOUS_INTERNAL_LINKING_DETAILS: 'SET_AUTONOMOUS_INTERNAL_LINKING_DETAILS',
  SET_REMAINING_DAY_PASS_CREDITS: 'SET_REMAINING_DAY_PASS_CREDITS',
};
